import { CvDateFormatter, DATEFORMAT } from "@cv-invision/cv.component-library.ux";

export class COLUMNS_RELIANCEFIRST {
	private _columns: Array<any>;

	constructor(dateService: CvDateFormatter) {
		this._columns = [
			{
				headerName: 'ID',
				field: 'id',
			},
			{
				headerName: 'Provider',
				field: 'provider',
			},
			{
				headerName: 'Provider ID',
				field: 'providerId',
			},
			{
				headerName: 'Loan Number',
				field: 'loanNumber',
			},
			{
				headerName: 'Created On',
				field: 'created',
				valueFormatter: params => dateService.format(DATEFORMAT.YYYY_MM_DD, params.data.created)
			},
			{
				headerName: 'Logs',
				width: 80,
				cellRenderer: 'CustomActionPartialOrdersCellComponent'
			}
		]
	}

	get columns(): Array<any> {
		return this._columns;
	}
};

export class PartialsOrderLogsColumnsModel {
	private _columns: Array<any>;
	constructor(dateService:CvDateFormatter) {
		this._columns = [
			{
				headerName: 'Log Action',
				field: 'action',
				width: 120
			},
			{
				headerName: 'Success',
				field: 'valid',
				width: 50
			},
			{
				headerName: 'Request',
				field: 'request',
				width: 50
			},
			{
				headerName: 'Http CodeResponse',
				field: 'httpStatusCodeResponse',
				width: 50
			},
			{
				headerName: 'Generated(Local)',
				field: 'created',
				valueFormatter: params => dateService.format(DATEFORMAT.YYYY_MM_DD, params.data.created),
				width: 50
			},
			{
				headerName: 'Message Request',
				field: 'messageRequest',
				width: 250,
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}

export class FILTER_RELIANCEFIRST  {
	provider: string;
	providerId: string;
	loanNumber: string;
	limit: number;

	constructor(provider = '', providerId = '', loanNumber = '', limit = 20) {
        this.provider = provider;
        this.providerId = providerId;
        this.loanNumber = loanNumber;
        this.limit = limit;
    }
};

export const DATA_RELIANCEFIRST = (data: any) => [
    { name: 'id', value: data.id },
    { name: 'provider', value: data.provider },
    { name: 'providerId', value: data.providerId },
    { name: 'source', value: data.source },
    { name: 'created', value: data.created },
    { name: 'updated', value: data.updated },
    { name: 'transactions', value: data.transactions.length },
	{ name: 'loanNumber', value: data.loanNumber}
];
